// React
import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

// Reactstrap
import { Card, Col, Row } from 'reactstrap';

// Injections
import {
  PageWrapper,
  FloatButton,
  LoadingScreen,
} from '../../containers/componentsInjection';
import { PlansInjection } from '../../containers/plansInjection';
import { assets } from '../../containers/assetsInjection';
import { DropdownDatatable } from '../../../../components/dropdownDatatable';

const Plans = () => {
  const [activeStatus, setActiveStatus] = useState('true');

  const { deletePlans, getPlans, plans, success, error } = PlansInjection();
  const { images } = assets;

  const history = useHistory();

  const handleDelete = (id) => {
    deletePlans(id);
  };

  const handleEdit = (values) => {
    const { id } = values;
    history.push(`/planos/edit/${id}`);
  };

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Nome</span>,
      sortable: false,
      width: '30%',
      selector: (cell) => {
        return (
          <React.Fragment>
            <div className="d-flex align-items-center fw-medium ">
              <Link to={`/planos/edit/${cell.id}`} className="currency_name">
                {cell.name}
              </Link>
            </div>
          </React.Fragment>
        );
      },
    },
    {
      name: <span className="font-weight-bold fs-13">Categoria</span>,
      selector: (row) => row.category_name,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Valor</span>,
      selector: (row) => row.price,
      sortable: true,
    },
  ];

  useEffect(() => {
    getPlans(activeStatus);
  }, [activeStatus]);

  return plans ? (
    <PageWrapper title={'Planos'}>
      <Row>
        <Col xs={12}>
          <Card>
            <DropdownDatatable
              title="Planos"
              isCard={false}
              titleButton="Novo plano"
              pagination
              persistTableHead
              perPage={10}
              isSearchRemote={false}
              keysSearch={['name']}
              data={plans ? plans : []}
              columns={columns}
              actions={[
                {
                  id: 1,
                  name: 'edit',
                  label: 'Editar',
                  onPress: (cellProps) =>
                    history.push(`/planos/edit/${cellProps.id}`),
                  icon: 'la-pen',
                  classNameColorIcon: 'primary',
                },
              ]}
              handleDelete={(cellProps) => handleDelete(cellProps)}
              hasStatusSelect
              handleStatusSelect={(e) => setActiveStatus(e.target.value)}
            />
          </Card>
        </Col>
      </Row>

      <FloatButton handleButton={() => history.push(`/planos/novo`)} />
    </PageWrapper>
  ) : (
    <PageWrapper title={'Planos'}>
      <Row>
        <LoadingScreen />
      </Row>
    </PageWrapper>
  );
};

export default Plans;
